<template>
	<section>
		<div class="row">
			<div class="col-8" @click="focusHslaInput">
				Contrast Ratio: {{ contrastRatio }}
			</div>
		</div>
		<div class="row">
			<div class="col-1">
				<button class="eyedropper-button" title="Open Eyedropper" @click.prevent="$emit('open-eyedropper')"><i class="fa fa-eyedropper"></i></button>
			</div>
			<div class="col">
				hsl:
				<input
					@focus="$emit('hsl-focused' ,true)"
					@blur="$emit('hsl-focused', false)"
					@input="onHslInput(0, $event.target.value)"
					type="number"
					ref="hslaInput"
					class="hsla-input"
					min="0"
					max="360"
					:value="hsl[0]"
				/>
				<input
					@focus="$emit('hsl-focused' ,true)"
					@blur="$emit('hsl-focused', false)"
					@input="onHslInput(1, $event.target.value)"
					type="number"
					class="hsla-input"
					min="0"
					max="100"
					:value="hsl[1]"
				/>
				<input
					@focus="$emit('hsl-focused' ,true)"
					@blur="$emit('hsl-focused', false)"
					@input="onHslInput(2, $event.target.value)"
					type="number"
					class="hsla-input"
					min="0"
					max="100"
					:value="hsl[2]"
				/>
			</div>
		</div>
	</section>
</template>

<script>
import util from '@/util'

export default {
	name: "ContrastRatio",
	props: {
		selectedColor: Object
	},
	computed: {
		// Single derivation shared with HueSlider; pure read, no side effects.
		derived() {
			return util.deriveColorFromHsla(this.selectedColor && this.selectedColor.hsla)
		},
		hsl() {
			return this.derived.hsl
		},
		contrastRatio() {
			if (!this.selectedColor || !this.selectedColor.hsla) return 0
			return this.derived.contrastRatio
		}
	},
	methods: {
		onHslInput(index, value) {
			// Ignore empty/partial input so clearing a field to retype doesn't snap the
			// channel to 0 (Number('') === 0) — which would grey the color and disable
			// the hue slider mid-edit. The field repopulates from the derived value.
			if (value === '' || !Number.isFinite(Number(value))) return
			const hsl = [...this.hsl]
			hsl[index] = Number(value)
			this.applyColor(`hsl(${hsl[0]}, ${hsl[1]}%, ${hsl[2]}%)`)
		},
		applyColor(hsla) {
			const derived = util.deriveColorFromHsla(hsla)
			Object.keys(derived).forEach(key => this.$set(this.selectedColor, key, derived[key]))
		},
		focusHslaInput() {
			this.$refs.hslaInput.focus()
		},
	}
};
</script>

<style scoped>
	.eyedropper-button { background: transparent; color: var(--text-color); padding: 5px; padding-top: 15px; margin: -5px; margin-left: 5px; }

	.hsla-input { padding-left: 0px; padding-bottom: 0; border: none; width: 10%; font-size: inherit; color: var(--preview-text-color); background: transparent; }

	input::-webkit-outer-spin-button,
	input::-webkit-inner-spin-button {
	-webkit-appearance: none;
	margin: 0;
	}
</style>
